const PERMISSION_KEY= "core:tenants";
const PAGE_URL = {
    TENANT_PAGE: "/admin/core/tenant",
    TENANT_DETAIL_PAGE: "/admin/core/tenant"
}

export {PERMISSION_KEY, PAGE_URL}

